
/**
 * Copyright (c) 2018 Microsoft Corporation
 * Modules Registration
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

const universal = require('react-universal-component').default;

/**
 * Register all available modules
 */
export const registerAllModules = (requiredModules) => {
    let binding = { modules: {}, dataActions: {} };
    const { log, error }  = console;
    const detailedWebpackError = (msg, errorObject) => { error(msg); error(errorObject); process.env.NODE_ENV !== 'development' && error('Run in dev mode to see full list of errors'); process.exit(50); }
    const handleError = (modPath, errObject) => {
        detailedWebpackError('Error with path: ' + modPath, errObject);
    }
    if (requiredModules) {
        requiredModules = requiredModules.map((module) => module.toLowerCase());
    }
    const isNotRegistered = (moduleName) => {
        return !requiredModules || requiredModules.length <= 0 || requiredModules.findIndex((module) => module === moduleName) !== -1;
    };

    try {


    isNotRegistered('fhi') && (binding.modules['fhi'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '__local__/../@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/fabrikam'),
            {
                chunkName: () => '__local__-..-@msdyn365-commerce-modules-fabrikam-design-kit-dist-lib-modules-fabrikam-fabrikam',
                ignoreBabelRename: true
            }
        ),
        $type: 'themeModule',
        dataActions: [],
        
        definitionPath: 'src/themes/fhi/fhi.definition.json',
        isNodeModule: true,
        moduleNamespace: '__local__',
        name: 'fhi',
        packageName: '__local__',
        
        parentDefinitionPath: 'node_modules/@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/fabrikam.definition.json',
        
        themeSettings: 'fhi.theme.settings.json',
        moduleDirectory: 'src/themes/fhi'
    });
            

    isNotRegistered('fhi-product-collection') && (binding.modules['fhi-product-collection'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                'partner/modules/fhi-product-collection/fhi-product-collection'),
            {
                chunkName: () => 'partner-modules-fhi-product-collection-fhi-product-collection',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [],
        
        definitionPath: 'src/modules/fhi-product-collection/fhi-product-collection.definition.json',
        isNodeModule: false,
        moduleNamespace: '__local__',
        name: 'fhi-product-collection',
        packageName: '__local__',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'src/modules/fhi-product-collection'
    });
            

    isNotRegistered('fhi-wishlist-items') && (binding.modules['fhi-wishlist-items'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                'partner/modules/fhi-wishlist-items/fhi-wishlist-items'),
            {
                chunkName: () => 'partner-modules-fhi-wishlist-items-fhi-wishlist-items',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'productAvailability',  path:'modules/fhi-wishlist-items/actions/get-product-availabilities-wishlist-items', runOn: 1},{name:'products',  path:'modules/fhi-wishlist-items/actions/get-items-in-wishlists', runOn: 1},{name:'wishlists',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id', runOn: 1}],
        
        definitionPath: 'src/modules/fhi-wishlist-items/fhi-wishlist-items.definition.json',
        isNodeModule: false,
        moduleNamespace: '__local__',
        name: 'fhi-wishlist-items',
        packageName: '__local__',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'src/modules/fhi-wishlist-items'
    });
            

        if (isNotRegistered('fhi-wishlist-items')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('fhi-wishlist-items')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('fhi-wishlist-items')) {
            const sanitizedActionPath = 'modules/fhi-wishlist-items/actions/get-items-in-wishlists';
            binding.dataActions[sanitizedActionPath] = require('partner/modules/fhi-wishlist-items/actions/get-items-in-wishlists');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('fhi-wishlist-items')) {
            const sanitizedActionPath = 'modules/fhi-wishlist-items/actions/get-product-availabilities-wishlist-items';
            binding.dataActions[sanitizedActionPath] = require('partner/modules/fhi-wishlist-items/actions/get-product-availabilities-wishlist-items');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

    
    } catch (e) {
        handleError('-', e);
    }
    
    return binding;
};